import { apiClient } from "@/lib/api";

// Company — Cal.com connection
export const getSchedulingSettings = () =>
  apiClient.get("/company/scheduling/settings");
export const connectCalcom = (payload) =>
  apiClient.post("/company/scheduling/connect", payload);
export const disconnectCalcom = () =>
  apiClient.delete("/company/scheduling/connect");

// Company — API-key auto-connect
export const inspectCalcom = (api_key) =>
  apiClient.post("/company/scheduling/calcom/inspect", { api_key });
export const finalizeCalcom = (payload) =>
  apiClient.post("/company/scheduling/calcom/finalize", payload);

// Company — invites & interviews
export const scheduleInvite = (payload) =>
  apiClient.post("/company/scheduling/invite", payload);
export const listCompanyInterviews = () =>
  apiClient.get("/company/scheduling/interviews");
export const patchInterview = (interviewId, body) =>
  apiClient.patch(`/company/scheduling/interviews/${interviewId}`, body);

// Candidate
export const listMyInterviews = () => apiClient.get("/scheduling/mine");

// Public booking context (no auth)
export const getBookingContext = (token) =>
  apiClient.get(`/schedule/${token}`);
